import { render } from "./PersonTree.vue?vue&type=template&id=476281aa"
import script from "./PersonTree.vue?vue&type=script&lang=js"
export * from "./PersonTree.vue?vue&type=script&lang=js"

import "./PersonTree.vue?vue&type=style&index=0&id=476281aa&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__